import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-jalali';
import MonthsViewHeading from './months_view_heading';

import * as defaultStyles from '../styles';


const months = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
];

export default class MonthSelector extends React.PureComponent {
    static propTypes = {
        styles: PropTypes.object,
        selectedMonth: PropTypes.object.isRequired,
    };

    static contextTypes = {
        setCalendarMode: PropTypes.func.isRequired,
        setMonth: PropTypes.func.isRequired,
    };

    state = {
        year: this.props.selectedMonth,
    };

    nextYear() {
        this.setState({
            year: this.state.year.clone().add(1, 'year'),
        });
    }

    prevYear() {
        this.setState({
            year: this.state.year.clone().subtract(1, 'year'),
        });
    }

    handleClick(key) {
        const {setMonth, setCalendarMode} = this.context;
        setMonth(moment(key, 'jM-jYYYY'));
        setCalendarMode('days');
    }

    render() {
        const {year} = this.state;
        const {selectedMonth, styles} = this.props;

        return (
            <div className="month-selector">
                <MonthsViewHeading
                    styles={styles}
                    year={year}
                    onNextYear={this.nextYear.bind(this) }
                    onPrevYear={this.prevYear.bind(this) }
                />
                <div style={{overflow: 'hidden'}}>
                    {months.map((name, key) => {
                        const buttonFingerprint = (key + 1) + '-' + year.format('jYYYY');
                        const selectedMonthFingerprint = selectedMonth.format('jM-jYYYY');
                        const isCurrent = selectedMonthFingerprint === buttonFingerprint;

                        return <button
                            key={key}
                            style={{
                                ...(isCurrent ? defaultStyles.activeButton : defaultStyles.button),
                                boxShadow: undefined,
                                float: 'right',
                                width: 'calc(100% / 3)',
                                minWidth: undefined,
                            }}
                            onClick={() => this.handleClick.bind(this)(buttonFingerprint)}>
                            {name}
                        </button>;
                    })}
                </div>
            </div>);
    }
}
